import { Controller } from '@hotwired/stimulus';
import { generateRsaKeyPair, wrapPrivateKeyWithPassword, b64encode } from '../vault_crypto';

export default class extends Controller {
  static targets = [
    'passwordField',
    'confirmationField',
    'passwordError',
    'confirmationError',
    'submitButton',
    'publicKey',
    'wrappedPrivateKey',
    'salt',
    'iv',
  ];
  static values = { minLength: Number, t: Object };

  connect() {
    this.passwordFieldTarget.addEventListener('input', () => this.validate());
    this.confirmationFieldTarget.addEventListener('input', () => this.validate());
  }

  validate() {
    const pw = this.passwordFieldTarget.value;
    const confirm = this.confirmationFieldTarget.value;
    const minLen = this.minLengthValue || 12;

    let valid = true;

    if (pw.length > 0 && pw.length < minLen) {
      this.passwordErrorTarget.textContent = this.tValue.password_too_short;
      this.passwordErrorTarget.classList.remove('hidden');
      valid = false;
    } else {
      this.passwordErrorTarget.classList.add('hidden');
    }

    if (confirm.length > 0 && pw !== confirm) {
      this.confirmationErrorTarget.textContent = this.tValue.passwords_do_not_match;
      this.confirmationErrorTarget.classList.remove('hidden');
      valid = false;
    } else {
      this.confirmationErrorTarget.classList.add('hidden');
    }

    this.submitButtonTarget.disabled = !(pw.length >= minLen && pw === confirm);
    return valid;
  }

  async generate(event) {
    event.preventDefault();
    if (!this.validate()) return;

    const password = this.passwordFieldTarget.value;
    const btn = this.submitButtonTarget;
    btn.disabled = true;
    btn.textContent = this.tValue.generating;

    try {
      const keyPair = await generateRsaKeyPair();
      const { wrappedKey, salt, iv } = await wrapPrivateKeyWithPassword(
        password,
        keyPair.privateKey
      );
      const exportedPub = await crypto.subtle.exportKey('spki', keyPair.publicKey);

      this.publicKeyTarget.value = b64encode(exportedPub);
      this.wrappedPrivateKeyTarget.value = b64encode(wrappedKey);
      this.saltTarget.value = b64encode(salt);
      this.ivTarget.value = b64encode(iv);

      this.passwordFieldTarget.disabled = true;
      this.confirmationFieldTarget.disabled = true;
      this.element.submit();
    } catch (e) {
      console.error('Vault init failed:', e);
      btn.disabled = false;
      btn.textContent = this.tValue.next;
      alert(this.tValue.key_generation_failed);
    }
  }
}
